import React from "react";
import { useLang } from "../../i18n/LanguageContext";

export default function Audience() {
  const { t } = useLang();
  return (
    <section id="audience" className="relative py-24 md:py-32 bg-[var(--aa-wine)] text-[var(--aa-cream)] overflow-hidden">
      <div className="pointer-events-none absolute inset-0 opacity-[0.06]">
        <div className="absolute -top-32 -left-24 w-[560px] h-[560px] rounded-full bg-[var(--aa-cream)]"></div>
        <div className="absolute -bottom-32 -right-24 w-[480px] h-[480px] rounded-full bg-[var(--aa-cream)]"></div>
      </div>

      <div className="relative mx-auto max-w-6xl px-6 md:px-8">
        <div className="reveal max-w-3xl">
          <div className="text-[11px] tracking-[0.24em] uppercase text-[var(--aa-cream)]/70 font-semibold mb-4">
            {t.audience.eyebrow}
          </div>
          <h2 className="font-display font-light text-4xl md:text-6xl leading-[1.05]">
            {t.audience.h2a} <span className="italic">{t.audience.h2b}</span>
          </h2>
          <p className="mt-6 text-[15px] md:text-lg text-[var(--aa-cream)]/80 max-w-2xl leading-relaxed">
            {t.audience.p}
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-5 md:gap-6">
          {t.audience.items.map((a, i) => (
            <div
              key={i}
              className="reveal lift relative rounded-3xl border border-white/15 bg-white/[0.04] backdrop-blur-sm p-8 md:p-9"
            >
              <div className="font-display text-5xl md:text-6xl italic text-[var(--aa-cream)]/25 leading-none">
                {a.tag}
              </div>
              <h3 className="font-display text-2xl md:text-3xl mt-4">{a.heading}</h3>
              <p className="mt-3 text-[14.5px] text-[var(--aa-cream)]/75 leading-relaxed">
                {a.body}
              </p>
            </div>
          ))}
        </div>

        <div className="reveal mt-16 grid grid-cols-2 md:grid-cols-4 gap-4">
          {t.audience.stats.map((s, i) => (
            <div
              key={i}
              className="rounded-2xl border border-white/12 px-5 py-6 bg-white/[0.03]"
            >
              <div className="font-display text-3xl md:text-4xl">{s.k}</div>
              <div className="text-xs mt-1 text-[var(--aa-cream)]/70 uppercase tracking-[0.16em]">
                {s.v}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
